// Platform availability copy — one string per outage, shared by every surface
// that has to say it.
//
// YAHOO: revoked API access for third-party apps registered before summer 2026
// (confirmed Jul 29 2026, ecosystem-wide, not specific to this app). Every
// Fantasy API call answers 403 "This application is not authorized to perform
// this action." The integration is intact and works the moment access returns —
// api/yahoo/* is untouched, and so are the flows behind these entry points.
//
// Lives here rather than in any one component because THREE separate surfaces
// announce it (the Almanac platform picker, the Settings import panel, and the
// Almanac Yahoo flow's sign-in step) and they must read identically. A copy per
// component is a copy that drifts.
//
// Split into lead + body so each surface can bold the lead the way the ESPN
// signpost on the Almanac landing bolds "ESPN:" — same treatment, not a new one.
export const YAHOO_UNAVAILABLE_LEAD = "Unavailable.";
export const YAHOO_UNAVAILABLE_BODY =
  "Yahoo revoked API access for third-party apps in July. I've applied to get it back.";
